/*! Copyright 2025 Lane Crawford, All Rights Reserved. */

/**
 *
 * [ module ]
 * discover -> feed
 *
 */

( function( LC, $ ) {

	"use strict";

	LC.discover = LC.discover || {};

	LC.discover.feed = lcmodule( function( exports ) {

		exports.moduleName = "discover.feed";

		// "exports"" is always passed in, and always
		// returned at the end. Bind "ex" as it's easier to type
		// "_this" is used for private binding and maintaining scope

		var ex = exports = $.extend( {}, window.lcmoduledefaults, exports ),
			_this = {};


		_this.MAX = 20;
		_this.START = 1;
		_this.URL = "/landingPages/discover-landing/json/articles.jsp";
		_this.historyState = LC.location.pathname;

		_this.atTop = false;
		_this.atBottom = false;


		ex.init = function() {

			_this.$scroller = $( window );
			_this.$list = $(".discover-landing__list");
			_this.$filters = $(".discover-landing__filters");
			_this.$checkboxes = _this.$filters.find("input[ type = checkbox ]");
			_this.$loadMore = $(".discover-landing__show-more");
			_this.$spinner = $(".discover-landing__prev-spinner, .discover-landing__next-spinner");

			_this.categories = _this.$list.data("bu") || "";
			_this.maxArticles = _this.$list.data("max-articles") || _this.MAX;
			_this.start = _this.$list.data("start") || _this.START;
			_this.end = _this.start + _this.maxArticles;
			_this.total = _this.$list.data("total");
			_this.page = _this.getPage( _this.start );

			ex.articleTemplate = Handlebars.compile( $("#tmpl-discover-article").html() );

			ex.initCategory();
			ex.initPosition();
			ex.events();
			ex.subscribe();

		};

		/**
		 * on init, we set the correct checkboxes to be
		 * selected, based on the parameter in the page (categories)
		 */
		ex.initCategory = function() {

			// un-set all the checkboxes first.
		   _this.$checkboxes.prop( "checked", false );

			if ( _this.categories !== "" ) {

				// split the categories that came from the JSP
				var categories = _this.categories.split(",");

				categories.forEach(function( category ) {

					// if the category is not empty/null/undefined
					if ( category ) {

						// check that category's checkbox
						_this.$checkboxes
							.filter("[ data-tag = " + category + " ]")
							.prop( "checked", true );

					}

				});

			}

		};

		/**
		 * return the list of articles currently on page
		 * @return {Object} | jQuery object of articles
		 */
		_this.$articles = function() {

			return _this.$list.find(".discover-article");

		};

		/**
		 * method to handle the positioning of the page
		 */
		ex.initPosition = function() {

			var $article,
				articleTop,
				articleId = LC.localStorage.getItem( "clickedDiscoverArticle" );

			// if there's a stored articleId from a previously-clicked article
			// then try to get it's element and add a css class and scroll the
			// user to that article
			if ( articleId ) {

				$article = _this.$articles().filter( "[ data-id=\"" + articleId + "\" ]");
				$article.addClass( ex.selectedClass );

			// or if the current page is > 1, as if the use was directed
			// here from a shared link, then make then we want to scroll
			// the user to the first article
			} else if ( _this.page > 1 ) {

				$article = _this.$articles().first();

			}

			// if we found an article, then scroll to it.
			if ( $article && $article.length ) {

				articleTop = $article.offset().top;
				$( window ).scrollTop( articleTop - 20 );

			}

			// remove the local storage item.
			LC.localStorage.removeItem( "clickedDiscoverArticle" );

		};

		/**
		 * method to update the total based on input
		 * @param {Number} total | value to assign to total
		 */
		_this.setTotal = function( total ) {

			_this.total = total || undefined;

		};

		/**
		 * return the currently viewing "page" of results, this
		 * is calculated by dividing the current viewing point
		 * against the maxArticles to display.
		 * @param  {Number} viewing | which index we are currently viewing
		 * @return {Number}       | page on which we are viewing
		 */
		_this.getPage = function( viewing ) {

			var max = _this.maxArticles;

			if ( typeof viewing !== "number" ) {
				viewing = 1;
			}

			return Math.floor( ( viewing - 1 ) / max ) + 1;

		};

		/**
		 * show the "load more" spinner
		 */
		_this.showSpinner = function() {

			_this.$spinner
				.addClass( ex.activeClass )
				.removeClass("opc-0");

		};

		/**
		 * hide the "load more" spinner
		 */
		_this.hideSpinner = function() {

			_this.$spinner
				.removeClass( ex.activeClass )
				.addClass("opc-0");

		};

		/**
		 * method to fire whenever a checkbox is changed,
		 * this method will collect the filters applied from
		 * the checkboxes and also re-set the start/end values.
		 */
		ex.handleCheckboxes = function() {

			// get the checkbox values
			var filters = ex.getFilters();

			// reset the start/end
			_this.start = 1;
			_this.end = _this.start + _this.maxArticles;

			// track the checkbox filters
			LC.track.trigger( "ga.event", {
				category: "Discover Landing",
				action: "Change Filter",
				label: filters
			});

			// get the new list of articles and
			// replace the current ones
			ex.getArticles({ categories: filters }, "replace" );

		};

		/**
		 * method to get the currently selected filters
		 * from the checkboxes
		 * @return {String} | comma-separated string of filters
		 */
		ex.getFilters = function() {

			var categories =
				_this.$checkboxes
					.filter(":checked")
					.map( function() {
						return $(this).data("tag");
					})
					.toArray()
					.join(",");

			// update the categories for the module
			_this.categories = categories;
			return categories;

		};

		/**
		 * method to get the next set of articles based on the
		 * current category and current end position
		 */
		ex.getNextArticles = function() {

			// only get the next articles if there are more to load
			if ( typeof _this.total !== "undefined" && _this.total > _this.end ) {

				// set the next results to start at the
				// current end position
				var nextStart = _this.end;

				// get the next set of articles, and then
				// append to the list
				ex.getArticles({ start: nextStart }, "append")
					.done(function() {

						// after the articles are appended, set "atBottom"
						// to false so the user can continue scrolling down
						// to load more.
						_this.atBottom = false;

					});

				// update the end position
				_this.end += _this.maxArticles;

			} else {

				LC.info( "🔻 Reached end of article results" );

			}

		};

		/**
		 * method to get the previous set of articles based on the
		 * current category and current start position
		 */
		ex.getPrevArticles = function() {

			// if the start position is not already at the absolute start
			if ( _this.start > 1 ) {

				// set the previous articles start position
				// to the current start position minus the article limit
				var prevStart = _this.start - _this.maxArticles;

				// if the new start position is anywhere that will
				// result in a new article being appended
				if ( prevStart > 1 - _this.maxArticles ) {

					// make sure the new start position is actually
					// a positive integer
					if ( prevStart < 1 ) {
						prevStart = 1;
					}

					// set the start position, get the new
					// articles and then prepend the results to the list.
					_this.start = prevStart;

					ex.getArticles({ start: prevStart }, "prepend" )
						.done(function() {

							_this.atTop = false;

						});

				}

			} else {

				LC.info( "🔺 Reached start of article results" );

			}

		};

		/**
		 * method to run when clicking the "show more" button, this
		 * will just get the next set of articles but also fade out
		 * the button.
		 */
		ex.loadMoreButton = function() {

			_this.atTop = false;
			_this.atBottom = true;
			_this.clickedShowMore = true;
			_this.$loadMore.fadeOutNicely();

			// track the user clicking "load more"
			LC.track.trigger( "ga.event", {
				category: "Discover Landing",
				action: "Click Load More",
				label: "on page: " + _this.page
			});

			ex.getNextArticles();

		};

		/**
		 * get the default values for the ajax request,
		 * allowing us to not always have to supply the
		 * whole request params object.
		 */
		_this.getAjaxDefaults = function() {

			return {
				quantity: _this.maxArticles || _this.MAX,
				start: _this.start || _this.START,
				categories: _this.categories || ""
			};

		};

		/**
		 * main function for sending the ajax request and
		 * updating the UI to reflect the current status
		 * @param  {Object} data           | ajax request data object
		 *                                 | {
		 *                                 |    start: integer,
		 *                                 |    quantity: integer,
		 *                                 |    categories: string
		 *                                 | }
		 * @param  {String} updateMethod   | string for the update method ("replace", "append", "prepend");
		 * @return {Promise}	           | the ajax request promise
		 */
		ex.getArticles = function( data, updateMethod ) {

			var ajaxData,
				defaults;

			// set the data for sending to the REST endpoint
			data = data || {};
			defaults = _this.getAjaxDefaults();
			ajaxData = _.extend( {}, defaults, data );

			// show the spinner/preloader depending
			// on the type of updateMethod
			if ( updateMethod === "replace" ) {
				LC.pubsub.trigger("preloader.open");
			} else {
				_this.showSpinner();
			}

			// cancel any pending ajax calls
			// this is to help if the user clicks the
			// checkboxes multiple times in a row
			if ( _this.ajax ) {
				_this.ajax.abort();
			}

			// make the ajax call with the data
			_this.ajax = $.ajax({
				dataType: "json",
				url: _this.URL,
				data: ajaxData
			})

				.done( function( response ) {

					var scrollPosition,
						pageHeightBefore,
						pageHeightAfter,
						pageHeightDifference;

					if ( updateMethod === "prepend" ) {

						// set the page state to the new page
						_this.page = _this.getPage( ajaxData.start );

						// get the original height and position of the page before content
						// refreshed, this is for comparison after content added
						pageHeightBefore = $("html").height();
						scrollPosition = _this.$scroller.scrollTop();

					}

					// add the new content to the page and refresh the UI
					ex.refresh( response, updateMethod );

					if ( updateMethod === "prepend" ) {

						// get the new page height after content added, this is
						// for comparison to see where the new scroll-position should be
						pageHeightAfter = $("html").height();
						pageHeightDifference = pageHeightAfter - pageHeightBefore;

						// after the articles have been prepended,
						// we need to set the page-position to where it should be
						// after we've added new articles above the user's current
						// scroll position.
						_this.$scroller.scrollTop( scrollPosition + pageHeightDifference );

					}

					// make sure any new articles are given the
					// correct lazy-load treatment!
					_this.$list.find(".js-lazy").lazy();

				})

				.always( function() {

					// always hide the spinner/loader
					_this.hideSpinner();
					LC.pubsub.trigger("preloader.close");

				});

			return _this.ajax;

		};

		/**
		 * refresh the user interface with the results given
		 * in the data object
		 * @param  {Object} data         | object containing total and list of articles
		 * @param  {String} updateMethod | string containing the method for updaing the UI
		 */
		ex.refresh = function( data, updateMethod ) {

			if ( !data || typeof data !== "object" ) {
				LC.error( "incorrect data passed in to refresh UI" );
			}

			var articles = data.articles,
				htmlList;

			if ( articles.length ) {

				htmlList = articles.map( function( article ) {

					var articleDate = new Date( article.date ),
						tagsArray = [],
						tagsString = "",
						isoDate = articleDate.toISOString(),
						displayDate,
						displayDateCN;


					// format the date displayed to the user
					displayDate = LC.format.date( articleDate, "MMMM d, yyyy" );
					displayDateCN = LC.format.date( articleDate, "yyyy年M月d日" );

					if ( LC.config.getValue("profile.locale") === "zh_CN" ) {
						displayDate = displayDateCN;
					}

					/**
					 * tagsArray holds an array of translated tags for use in displaying to the UI
					 * @return {Array} | [ "女士", "xmas", "seasonal", "男士" ]
					 */
					tagsArray = article.tags.map( function( value ) {
						return value.name;
					});

					/**
					 * tagsString holds a string of non-translated tags for use in meta-data
					 * @return {String} | 女士, xmas, seasonal, 男士"
					 */
					tagsString = article.tags.map( function( value ) {
						return value.nameDefault;
					}).join();

					// return the article block with the correct
					// data after it has run through a Handlebars
					// template parser
					return ex.articleTemplate({

						articleClass: "discover-article",
						id: article.id,
						index: article.num,
						image: article.image,
						title: article.title,
						titleDefault: article.titleDefault,
						isoDate: isoDate,
						displayDate: displayDate,
						canonicalUrl: article.url,
						showTags: true,
						displayTags: tagsArray, // javascript array
						metaTags: tagsString, // comma-separated string
						metaKeywords: article.keywords, // comma-separated string
						contentClass: "column / mar-b30"

					}).trim();

				}).join("");


				/**
				 * use a switch to determine how to add the new
				 * articles to the list.
				 */
				switch ( updateMethod ) {

					case "append":

						$(".discover-landing__list")
							.append( htmlList );

						break;

					case "prepend":

						$(".discover-landing__list")
							.prepend( htmlList );

						break;

					default:

						$(".discover-landing__list")
							.empty()
							.append( htmlList );

						break;

				}

			}

			// update the global total state with the
			// value returned in the JSON response. This is
			// so that we can properly handle loading more
			// in the next/prev methods.
			_this.setTotal( data.total );

			// if we've gotten a new list...
			if ( updateMethod === "replace" ) {

				// update the url bar with correct url
				ex.setHistoryState();

			}

		};

		/**
		 * method to handle the URL re-writing when user scrolls
		 * down the page, or changes category from the filters available
		 * @param {String} category | the category name to apply to url (optional)
		 * @param {Number} page     | the page number to apply to the url (optional)
		 */
		ex.setHistoryState = function( category, page ) {

			var base = "/discover/feed",
				url = base;

			category = category || _this.categories;
			page = page || _this.page;

			// add "/bu" if needed
			if ( category ) {
				url = url + "/" + category;
			}

			// add "/page/2" if needed
			if ( page && page > 1 ) {
				url = url + "/page/" + page;
			}

			// add the final "/"
			url += "/";


			 // only update history and fire pageview if it
			 // is a different url/path to previously.
			if ( _this.historyState !== url ) {

				// update the current URL, but
				// do not add a new history state. This is
				// so the user doesn't have a ton of history to
				// go through to get to previous page.
				history.replaceState( null, null, url );

				// fire page view with "/discover/feed/..."
				LC.track.trigger( "pageview", { pageName: url });

				// update previous history state
				_this.historyState = url;

			}

			return url;

		};

		/**
		 * method to handle the global scroll updates
		 * @param  {Object} data | object returned from the "windowScroll" pubsub
		 */
		ex.handleScroll = function( data ) {

			if ( !data || typeof data !== "object" ) {

				LC.warn( "Can't fire scroll event without scroll data" );
				return;

			}

			// get the position (top/bottom) of the article
			// list; for validating whether user is at the top/bottom
			var listTop = _this.$list.offset().top,
				listBottom = listTop + _this.$list.height(),
				articleHeight,
				atTopOfList,
				atBottomOfList;

			// height of an article item
 			articleHeight = _this.$articles().first().height();
 			// user is almost at the top of the list
			atTopOfList = ( data.windowTop <= listTop + ( articleHeight / 2 ) );
			// user is almost at the bottom of list
			atBottomOfList = ( data.windowBottom >= listBottom - articleHeight );

			// if user is anywhere other than the top/bottom,
			// then set the booleans to false so that when they
			// next reach the top/bottom, they can load more articles.
			if ( !atTopOfList && !atBottomOfList ) {

				_this.atTop = false;
				_this.atBottom = false;

			}

			// check if the user is almost at the top of the list
			// and start preloading the previous articles
			if ( atTopOfList ) {

				// use the boolean "atTop" to check if the user
				// had previously been anywhere above the list,
				// we dont want to load more articles until user
				// actually scrolls.
				if ( _this.atTop === false ) {
					ex.getPrevArticles();
				}

				_this.atTop = true;
				_this.atBottom = false;

			}

			// check if user is almost at bottom of list
			// and start preloading the next articles
			if ( atBottomOfList ) {

				// only load more articles if they previously
				// clicked "show more" button
				if ( _this.clickedShowMore ) {

					// use the boolean "atBottom" to check if the user
					// was already at the bottom of the list. We don't want
					// to continue loading more until they actually scroll
					// to the bottom.
					if ( _this.atBottom === false ) {
						ex.getNextArticles();
					}

				}

				_this.atTop = false;
				_this.atBottom = true;

			}

		};

		/**
		 * method for handling the pagination on scroll,
		 * takes the scroll data and then checks for the first
		 * visible article. Subsequently gets the page# from that
		 * article index, and finally updates the page url.
		 *
		 * @param  {Object} data 			| data object returned by the windowScroll pubsub
		 * @return {String}					| returns the page path (url)
		 */
		ex.handleScrollPaging = _.debounce( function( data ) {

			if ( !data || typeof data !== "object" ) {

				LC.warn( "Can't fire scroll paging without scroll data" );
				return LC.location.pathname;

			}

			var start = _this.start,
				$firstVisible;

			// get the first visible discover article in the viewport
			$firstVisible =
				_this.$list
					.find(".discover-article")
					.filter( function() {

						var $this = $(this);
						return ( $this.offset().top + $this.height() ) > data.windowTop;

					}).first();

			_this.page = _this.getPage( start + $firstVisible.index() );

			return ex.setHistoryState();

		}, 250 );

		/**
		 * method to open an article when clicked on
		 * @param  {Object} article | a jQuery object of the article brick
		 */
		ex.openArticle = function( article ) {

			var $article = $( article ),
				articleUrl;

			if ( !$article.length ) {

				LC.warn( "Cannot open article with no given parameter" );
				return;

			}

			articleUrl =
				$article
					.find( ".discover-article__link" )
					.attr( "href" );

			LC.preloader
				.open()
				.done( function() {
					LC.location.href = articleUrl;
				});


		};

		/**
		 * save the article that the user just clicked on
		 * so that we can re-position them after they return
		 * from reading the article.
		 * @param  {Object} article | a jQuery object of the article brick
		 */
		ex.saveClickedArticle = function( article ) {

			var $article = $( article ),
				articleId;

			if ( !$article.length ) {

				LC.warn( "Cannot open article with no given parameter" );
				return;

			}

			articleId = $article.data("id");
			LC.localStorage.setItem( "clickedDiscoverArticle", articleId );

		};



		/**
		 * interaction events
		 */
		ex.events = function() {

			var namespace = ".discoverFeed",
				change = "change" + namespace,
				click = "click" + namespace;

			// user clicks checkbox, handle that by loading
			// a new list of articles with those filters
			_this.$checkboxes
				.off( namespace )
				.on( change, ex.handleCheckboxes );

			// when the "show more" button is clicked,
			// we fade it out and then get the next articles.
			_this.$loadMore
				.off( namespace )
				.on( click, ex.loadMoreButton );

			// handle the clicking of articles to do
			// a overlay animation while loading
			_this.$list
				.off( namespace )
				.on( click, ".discover-article__content", function( e ) {

					var $elem = $(this);

					e.preventDefault();
					ex.saveClickedArticle( $elem );
					ex.openArticle( $elem );

				});

		};



		/**
		 * pubsub events
		 */
		ex.subscribe = function() {

			LC.pubsub
				.off("windowScroll.discoverFeed")
				.on("windowScroll.discoverFeed", function( e, data ) {

					ex.handleScroll( data );
					ex.handleScrollPaging( data );

				});

		};

		return exports;

	}({}));

}( window.LC = window.LC || {}, jQuery ));

 //# sourceURL=discover.js
